import React from 'react';
import { Product } from '../types/types';
import { CONFIG } from '../data/config';
import { PlusIcon } from 'lucide-react';
interface ProductCardProps {
  product: Product;
  onAdd: (product: Product) => void;
}
export function ProductCard({
  product,
  onAdd
}: ProductCardProps) {
  return <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-302">
      <div className="flex-1" data-id="element-303">
        <div className="flex justify-between items-start mb-2" data-id="element-304">
          <h3 className="font-heading font-semibold text-gray-900 text-base leading-tight" data-id="element-305">
            {product.name}
          </h3>
          <span className="font-semibold text-verde-dark whitespace-nowrap ml-2 text-sm" data-id="element-306">
            {CONFIG.CURRENCY_SYMBOL}
            {product.price.toLocaleString()}
          </span>
        </div>
        {product.description && <p className="text-gray-500 text-xs leading-snug mb-3 line-clamp-3" data-id="element-307">
            {product.description}
          </p>}
      </div>

      <button onClick={() => onAdd(product)} className="mt-auto w-full bg-verde-light/20 text-verde-dark font-medium py-3 rounded-xl flex items-center justify-center gap-1 active:bg-verde active:text-white transition-colors min-h-[48px]" data-id="element-308">
        {product.customizable ? <>
            Personalizar <PlusIcon className="w-4 h-4" data-id="element-309" />
          </> : <>
            Agregar <PlusIcon className="w-4 h-4" data-id="element-310" />
          </>}
      </button>
    </div>;
}